export const primary = {
  50: "#AEF9F5",
  100: "#5DF4EA",
  200: "#20EFE3",
  300: "#0CACA3",
  400: "#087069",
  500: "#054743",
  600: "#043532",
  700: "#032C2A",
  800: "#021B19",
  900: "#010908"
};

export const neutral = {
  50: "#F7F7F7",
  100: "#E8E8E8",
  200: "#DFE1E0",
  300: "#D7D9D8",
  400: "#CFCFCF",
  500: "#BFC2C1",
  600: "#8E9391",
  700: "#7A807E",
  800: "#262727",
  900: "#090A0A"
};

export const success = {
  50: "#ECFDF5",
  100: "#D1FAE5",
  200: "#A7F3D0",
  300: "#6EE7B7",
  400: "#34D399",
  500: "#10B981",
  600: "#059669",
  700: "#047857",
  800: "#065F46",
  900: "#064E3B"
};

export const error = {
  50: "#FEF2F2",
  100: "#FEE2E2",
  200: "#FECACA",
  300: "#FCA5A5",
  400: "#F87171",
  500: "#EF4444",
  600: "#DC2626",
  700: "#B91C1C",
  800: "#991B1B",
  900: "#7F1D1D"
};

/** The "New:" announcement look (ChartNotesTabsBanner, PatientTabsReorderBanner): a pale blue card
 *  with dark blue text. Shared so new announcements match the existing ones. */
export const announcement = {
  background: "#E6F1FB",
  border: "#B5D4F4",
  text: "#0C447C",
  accent: "#185FA5"
};

// The new E-Documents notice (Chart Notes band and chart menu pill). Bright on purpose: clinics
// asked for something staff cannot miss. Both gradient ends keep white text at 4.5:1 or better.
export const newDocuments = {
  gradientStart: "#0B4FD8",
  gradientEnd: "#0A6CE0",
  text: "#FFFFFF",
  action: "#FFD400",
  actionText: "#0B2A80",
  glow: "rgba(11, 95, 255, 0.28)",
  tint: "#E6F0FF",
  tintText: "#0B3FB0"
};

export const misc = {
  lightMutedPurple: "#F5F6F8",
  mutedPurple: "#f0f2ff",
  highlightPurple: "#e4d5f2",
  grayAsphalt: "#505F7A",
  blackAsphalt: "#0F1010",
  purpleText: "#762FBD",
  linkColor: "#551A8B",
  selectedMenuitem: "#b38bd3",
  subMenuItem: "#e4cdfa66",
  selectedSubMenuItem: "#e4cafd",
  lightYellow: "#fffde7",
  warningYellow: "#FFEC99",
  darkYellow: "#fcc02a",
  // A speed-dial star on a white row: darkYellow is 1.6:1 on white, this
  // clears the 3:1 non-text minimum (ENG-2177 design review).
  starGold: "#B7791F",
  lightGreen: "#daefe9",
  veryLightGreen: "#edf4f3",
  darkGreen: "#9ac4bb",
  default: "#ebebeb",
  warningText: "#e65100",
  lightLavender: "#f8f3fe",
  lavenderMist: "#f5f5fc",
  lavenderMistDark: "#e6e6f8",
  mutedLavender: "#eee9f3",
  suno: "#4A1350",
  sunoGreen: primary[400],
  quickbooks: "#2D9F1D",
  // Chat v2 (SN-19155): light-theme values from the design prototype.
  chatLavender: "#C79AEB",
  chatPlum: "#2E1832",
  chatSidebar: "#EFF1FB"
};

/** Login-screen product rotation (`features/app-layout/login-promo/`). Voice AI's teal and
 *  call-card plum come from the Suno Voice AI launch artwork; Scribes keeps the side-menu lilac.
 *  `voiceDeepTeal` is the panel behind the Voice slide, a dark slate teal next to the Scribes plum. */
export const loginPromo = {
  voiceTeal: "#4FD8C4",
  callCard: "#6A4A72",
  voiceDeepTeal: "#13272E"
};
